import { GraphEdge } from "../../../models/GraphEdge.interface";
import { GraphNode } from "../../../models/GraphNode.interface";

export type FilterablePropertyTarget = "node" | "channel";

export class FilterableProperty {
  constructor(
    public target: FilterablePropertyTarget,
    public variable: string
  ) {}

  get key(): string {
    return this.target + "." + this.variable;
  }

  getValue(obj: GraphNode | GraphEdge) {
    return obj[this.variable];
  }
}
